export const colors = {
  primary: "#2196F3",
  secondary: "black",
  background: "#282c34",
  text: "white",
};
